export const OPEN_CAMPAIGN_PLACE_EDITOR = 'OPEN_CAMPAIGN_PLACE_EDITOR';
export type OPEN_CAMPAIGN_PLACE_EDITOR = typeof OPEN_CAMPAIGN_PLACE_EDITOR;

export interface OpenCampaignPlaceEditor {
    type: OPEN_CAMPAIGN_PLACE_EDITOR;
    editorId: string;
}

export function openCampaignPlaceEditorAction(editorId: string): OpenCampaignPlaceEditor {
    return {
        type: OPEN_CAMPAIGN_PLACE_EDITOR,
        editorId
    };
}
